import { render, staticRenderFns } from "./AdminTeamClosure.vue?vue&type=template&id=5c9957cb&"
import script from "./AdminTeamClosure.vue?vue&type=script&lang=js&"
export * from "./AdminTeamClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports